import { twMerge } from "tailwind-merge";
import { ImageBase, type ImageBaseProps } from "@core/ui";
import { Loader } from "@themes/pollinator/ui/Loader";

export type Props = Omit<ImageBaseProps, "renderLoading" | "renderError">;

/**
 * Styled image component wrapping ImageBase.
 * Shows a loading spinner while the image loads.
 */
export function Image({ src, alt, className, imageClassName, delay, ...props }: Props) {
  return (
    <ImageBase
      src={src}
      alt={alt}
      delay={delay}
      className={twMerge("relative", className)}
      imageClassName={twMerge(
        "h-full w-full object-contain transition-opacity duration-300",
        imageClassName
      )}
      renderLoading={() => <Loader isAbsolute innerClassName="h-14 w-14" />}
      data-testid="image"
      {...props}
    />
  );
}

export default Image;

